var map = {
	"./assets/images/procution/pc/banner-1.jpg": "d887",
	"./assets/images/universities/mobile/banner-1.jpg": "fa7c",
	"./assets/images/universities/pc/banner-1.jpg": "2cc3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "309f";